// extracted by mini-css-extract-plugin
export default {"list":"usp-block-module--list--b7626","item":"usp-block-module--item--c6d61","icon":"usp-block-module--icon--2d2db"};